import { AbstractEntity } from "../AbstractEntity";
import Signature from "../Signature";
import { getUtcNow } from "../../utils";
export default class RecordFile extends AbstractEntity {
    createdTimestamp;
    author;
    filename;
    mimeType;
    filesize;
    fileSignature;
    signature;
    constructor(recordFile = {}) {
        super();
        Object.assign(this, { createdTimestamp: getUtcNow() }, recordFile);
    }
}
//# sourceMappingURL=RecordFile.js.map